export default "__VITE_ASSET__5906bea8__"